import { EnterpriseResourceParameters, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';

const extent = {
    resourceCategories: true,
    resourceCategoryAssignments: false,
    resourceFeatures: false,
    resourceFeatureAssignments: false,
    resources: false,
    slots: false,
} as const;

type UseResourceCategoriesSuspenseQueryParams = Omit<EnterpriseResourceParameters, 'extent'> & Partial<WithServiceId>;

export const useResourceCategoriesSuspenseQuery = ({ serviceId, ...other }: UseResourceCategoriesSuspenseQueryParams) =>
    useRepositorySuspenseQuery(
        'resources',
        'getAll',
        {
            ...other,
            extent,
        },
        {
            select: ({ resourceCategories }) =>
                serviceId
                    ? resourceCategories?.filter((resourceCategory) => resourceCategory.serviceId === serviceId)
                    : resourceCategories,
        }
    );
